import React from 'react';

import {CssBaseline} from '@mui/material';
import {ThemeProvider} from '@mui/material/styles';

import { AppProvider } from './stores/AppStore';
import { UserProvider } from './stores/UserStore';
import Router from './Router';
import Header from './Header';
import smartengoTheme from './utils/theme';

const App = () => {
    return (
        <ThemeProvider theme={smartengoTheme}>
            <CssBaseline/>
            <AppProvider>
                <UserProvider>
                    <Header />
                    <Router />
                </UserProvider>
            </AppProvider>
        </ThemeProvider>
    );
};

export default App;
